import { prepareMessages } from '@creditinfo-ui/messages/node';

export const m = prepareMessages('unsavedChanges', [
	['prompt', 'Changes you made may not be saved.'],
]);
